import GenerateTicketsPerPaxCta from './GenerateTicketsPerPaxCta';

export default GenerateTicketsPerPaxCta;
